<template>
   <div class="home">
       <div class="container">
           <Bairshlaar></Bairshlaar>
           <div class="main">
             <div class="main_tab">
               <div class="row">
                 <!--                                       <div class="col-6 col-md-3">-->
                 <!--                                           <div class="feature-box">-->
                 <!--                                               <router-link to="/tusgai">-->
                 <!--                                                   <div class="feat-text">-->
                 <!--                                                       <img src="../assets/item/certificate2.png">-->
                 <!--                                                       <p>Тусгай зөвшөөрөл</p>-->
                 <!--                                                       <span>Мэргэжил сургалт, үйлдвэрлэлийн төв, Политехник коллеж</span>-->
                 <!--                                                   </div>-->
                 <!--                                               </router-link>-->
                 <!--                                           </div>-->
                 <!--                                       </div>-->
                 <!--                                       <div class="col-6 col-md-3">-->
                 <!--                                           <div class="feature-box">-->
                 <!--                                               <router-link to="/SBG">-->
                 <!--                                                   <div class="feat-text">-->
                 <!--                                                       <img src="../assets/item/certificate.png">-->
                 <!--                                                       <p>Мэргэжлийн сургалтын бүртгэлийн гэрчилгээ</p>-->
                 <!--                                                       <span>Сургалтын төв</span>-->
                 <!--                                                   </div>-->
                 <!--                                               </router-link>-->
                 <!--                                           </div>-->
                 <!--                                       </div>-->
                 <!--                                       <div class="col-md-6">-->
                 <!--                                           <div class="feature-box">-->
                 <!--                                               <router-link to="/sur">-->
                 <!--                                                   <div class="feat-text">-->
                 <!--                                                       <img src="../assets/item/business-and-finance2.png">-->
                 <!--                                                       <p>Сургалтын байгууллага</p>-->
                 <!--                                                       <span>Политехник коллеж, мэргэжил сургалт үйлдвэрлэлийн төв</span>-->
                 <!--                                                   </div>-->
                 <!--                                               </router-link>-->
                 <!--                                           </div>-->
                 <!--                                       </div>-->
                 <!--                                        <div class="col-md-6">-->
                 <!--                                          <div class="feature-box">-->
                 <!--                                            <router-link to="/s_tuv">-->
                 <!--                                              <div class="feat-text">-->
                 <!--                                                <img src="../assets/item/certificate.png">-->
                 <!--                                                <p>Сургалтын төв</p>-->
                 <!--                                                <span>Сургалтын төв</span>-->
                 <!--                                              </div>-->
                 <!--                                            </router-link>-->
                 <!--                                          </div>-->
                 <!--                                        </div>-->
                 <!--                                       <div class="col-6 col-md-3">-->
                 <!--                                           <div class="feature-box">-->
                 <!--                                               <a href="http://chadamj.tvets.edu.mn" target="_blank">-->
                 <!--                                                   <div class="feat-text">-->
                 <!--                                                       <img src="../assets/item/line.png">-->
                 <!--                                                       <p>Чадамжийн сан</p>-->
                 <!--                                                       <span>Мэргэжлийн сургалт, мэргэжлийн боловсрол, техникийн боловсрол</span>-->
                 <!--                                                   </div>-->
                 <!--                                               </a>-->
                 <!--                                           </div>-->
                 <!--                                       </div>-->
               </div>
               <div class="row">
                 <div class="col-6 col-md-3">
                   <div class="feature-box">
                     <router-link to="/sur">
                       <div class="feat-text">
                         <img src="../assets/item/business-and-finance2.png">
                         <p>Сургалтын байгууллага</p>
                         <span>Политехник коллеж, мэргэжил сургалт үйлдвэрлэлийн төв</span>
                       </div>
                     </router-link>
                   </div>
                 </div>
                 <div class="col-6 col-md-3">
                   <div class="feature-box">
                     <router-link to="/hvnii_nuuts">
                       <div class="feat-text">
                         <img src="../assets/item/friends.png">
                         <p>Багш хүний нөөц</p>
                         <span>Техникийн боловсрол, мэргэжлийн боловсрол</span>
                       </div>
                     </router-link>
                   </div>
                 </div>
                 <!--                                       <div class="col-6 col-md-3">-->
                 <!--                                           <div class="feature-box">-->
                 <!--                                             <a href="javascript:void(0)">-->
                 <!--                                                   <div class="feat-text">-->
                 <!--                                                       <img src="../assets/item/computer.png">-->
                 <!--                                                       <p>Цахим сургалт</p>-->
                 <!--                                                       <span>Цахим сургалт</span>-->
                 <!--                                                   </div>-->
                 <!--                                             </a>-->
                 <!--&lt;!&ndash;                                             <a href="https://mergejil-elearning.de/Resource%20Pool/content/?fbclid=IwAR0d22lVy0j8XxpmV1LmXoGGkoy__fRHdeEdZXbY50RQ561FBgZiL1hUL8g#/" target="_blank">&ndash;&gt;-->
                 <!--&lt;!&ndash;                                               <div class="feat-text">&ndash;&gt;-->
                 <!--&lt;!&ndash;                                                 <img src="../assets/item/computer.png">&ndash;&gt;-->
                 <!--&lt;!&ndash;                                                 <p>Цахим сургалт</p>&ndash;&gt;-->
                 <!--&lt;!&ndash;                                                 <span>Цахим сургалт</span>&ndash;&gt;-->
                 <!--&lt;!&ndash;                                               </div>&ndash;&gt;-->
                 <!--&lt;!&ndash;                                             </a>&ndash;&gt;-->
                 <!--                                           </div>-->
                 <!--                                       </div>-->
                 <div class="col-6 col-md-3">
                   <div class="feature-box">
                     <router-link to="/orchin">
                       <div class="feat-text">
                         <img src="../assets/item/desk.png">
                         <p>Сургалтын орчин</p>
                         <span>Сургалтын орчин, хэрэглэгдэхүүн</span>
                       </div>
                     </router-link>
                   </div>
                 </div>
                 <div class="col-6 col-md-3">
                   <div class="feature-box">
                     <router-link to="/tetgeleg">
                       <div class="feat-text">
                         <img src="../assets/item/business-and-finance5.png">
                         <p>Тэтгэлэг</p>
                         <span>Тэтгэлэг тайлан мэдээ</span>
                       </div>
                     </router-link>
                   </div>
                 </div>
                 <!--                                       <div class="col-6 col-md-3">-->
                 <!--                                           <div class="feature-box">-->
                 <!--                                               &lt;!&ndash;                               <a href="">&ndash;&gt;-->
                 <!--                                               <div class="feat-text" @click="erpUnelgee = true">-->
                 <!--                                                   <img src="../assets/item/essay1.png" class="none">-->
                 <!--                                                   &lt;!&ndash;                                       <img src="../assets/item/essay1.png" >&ndash;&gt;-->
                 <!--                                                   <p>RPL үнэлгээ</p>-->
                 <!--                                                   <span>Албан ба албан бус сургалт, амьдрах орчны хүрээнд мэдлэг, ур чадввар эзэмшсэн иргэний мэргэшлийг түвшинг үнэлж, үнэлгээг баталгаажуулах, гэрчилгээжүүлэх</span>-->

                 <!--                                               </div>-->
                 <!--                                               &lt;!&ndash;                               </a>&ndash;&gt;-->
                 <!--                                           </div>-->
                 <!--                                       </div>-->
               </div>
               <div class="row">
                 <div class="col-6 col-md-3">
                   <div class="feature-box">
                     <a  @click="modal1 = true">
                       <div class="feat-text">
                         <img src="../assets/item/gerchilgee.png" >
                         <p>Гэрчилгээ, үнэмлэх, диплом шалгах</p>
                         <span>Мэргэжлийн үнэмлэх, мэргэжлийн боловсролын үнэмлэх, мэргэжлийн диплом, чардамжийн гэрчилгээ</span>
                       </div>
                     </a>
                   </div>
                 </div>
                 <div class="col-6 col-md-3">
                   <div class="feature-box">
                     <!--                               <a href="">-->
                     <div class="feat-text" @click="nuhunOgolt = true">
                       <img src="../assets/item/expenses1.png" class="none">
                       <!--                                       <img src="../assets/item/expenses1.png">-->
                       <p>Нөхөн олголт</p>
                       <span>Төгсөгчийн боловсролын баримт бичгийн нөхөн олголт</span>

                     </div>
                     <!--                               </a>-->
                   </div>
                 </div>
                 <div class="col-6 col-md-3">
                   <div class="feature-box">
                     <router-link to="/statistic_cat">
                       <div class="feat-text">
                         <img src="../assets/item/business-and-finance6.png">
                         <p> Статистик</p>
                         <span>Суралцагч, сургалтын байгууллага, хүний нөөц</span>
                       </div>
                     </router-link>
                   </div>
                 </div>
                 <div class="col-6 col-md-3">
                   <div class="feature-box">
                     <div class="feat-text">
                       <img src="../assets/item/shilenDanc.png" class="last_row">
                       <p>Шилэн данс</p>
                       <ul>
                         <li class="shilendans" :key="index" v-for="(shilendan, index) in shilendans"><a :href="shilendan.link" target="_blank">{{shilendan.shilendans}}</a></li>
                       </ul>
                       <!--                                   <ul>-->
                       <!--                                       <li class="shilendans"><a href="https://shilendans.gov.mn/orglist/41" target="_blank">Сургалтын байгууллагуудын хувьсах зардал</a></li>-->
                       <!--                                       <li class="shilendans"><a href="https://info.shilendans.gov.mn/login" target="_blank">Мэргэжлийн боловсрол, сургалтын үнэлгээ, мэдээлэл арга зүйн төвийн шилэн данс</a></li>-->
                       <!--                                   </ul>-->
                     </div>
                   </div>
                 </div>
               </div>
               <div class="row">
                 <!--                                       <div class="col-6 col-md-3">-->
                 <!--                                           <div class="feature-box">-->
                 <!--                                               <a href="http://mlsp.gov.mn/nnews/394" target="_blank">-->
                 <!--                                                   <div class="feat-text">-->
                 <!--                                                       <img src="../assets/item/hnhy_yam.png" class="last_row">-->
                 <!--                                                       <p>ХНХЯ, Мэргэжлийн боловсрол, сургалтын...</p>-->
                 <!--                                                       <span>ХНХЯ, мэргэжлийн боловсрол, сургалтын бодлогын хэрэгжилтийг зохицуулах газар</span>-->
                 <!--                                                   </div>-->
                 <!--                                               </a>-->
                 <!--                                           </div>-->
                 <!--                                       </div>-->
                 <!--                                       <div class="col-6 col-md-3">-->
                 <!--                                           <div class="feature-box">-->
                 <!--                                               <router-link to="/mbsut">-->
                 <!--                                                   <div class="feat-text">-->
                 <!--                                                       <img src="../assets/item/small_logo.png" class="last_row">-->
                 <!--                                                       <p>Мэргэжлийн боловсрол, сургалтын үнэлгээ мэдээлэл, аргазүйн төв</p>-->
                 <!--                                                       <span>Мэргэжлийн боловсрол, сургалтын үнэлгээ мэдээлэл, аргазүйн төв</span>-->
                 <!--                                                   </div>-->
                 <!--                                               </router-link>-->
                 <!--                                           </div>-->
                 <!--                                       </div>-->
                 <div class="col-6 col-md-3">
                   <div class="feature-box">
                     <router-link to="/tvnshlel">
                       <div class="feat-text">
                         <img src="../assets/item/bank-check.png" class="last_row">
                         <p> Нийгмийн түншлэл</p>
                         <span>Төсөл хөтөлбөрүүд, төрийн бус байгууллагууд, аж ахуй нэгжүүд</span>
                       </div>
                     </router-link>
                   </div>
                 </div>
               </div>
             </div>
<!--               <Tabs value="name1">-->
<!--                               <TabPane label="БҮГД" name="name1">-->
<!--                                   <div class="main_tab">-->
<!--                                      <div class="row">-->
<!--&lt;!&ndash;                                       <div class="col-6 col-md-3">&ndash;&gt;-->
<!--&lt;!&ndash;                                           <div class="feature-box">&ndash;&gt;-->
<!--&lt;!&ndash;                                               <router-link to="/tusgai">&ndash;&gt;-->
<!--&lt;!&ndash;                                                   <div class="feat-text">&ndash;&gt;-->
<!--&lt;!&ndash;                                                       <img src="../assets/item/certificate2.png">&ndash;&gt;-->
<!--&lt;!&ndash;                                                       <p>Тусгай зөвшөөрөл</p>&ndash;&gt;-->
<!--&lt;!&ndash;                                                       <span>Мэргэжил сургалт, үйлдвэрлэлийн төв, Политехник коллеж</span>&ndash;&gt;-->
<!--&lt;!&ndash;                                                   </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                               </router-link>&ndash;&gt;-->
<!--&lt;!&ndash;                                           </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                       </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                       <div class="col-6 col-md-3">&ndash;&gt;-->
<!--&lt;!&ndash;                                           <div class="feature-box">&ndash;&gt;-->
<!--&lt;!&ndash;                                               <router-link to="/SBG">&ndash;&gt;-->
<!--&lt;!&ndash;                                                   <div class="feat-text">&ndash;&gt;-->
<!--&lt;!&ndash;                                                       <img src="../assets/item/certificate.png">&ndash;&gt;-->
<!--&lt;!&ndash;                                                       <p>Мэргэжлийн сургалтын бүртгэлийн гэрчилгээ</p>&ndash;&gt;-->
<!--&lt;!&ndash;                                                       <span>Сургалтын төв</span>&ndash;&gt;-->
<!--&lt;!&ndash;                                                   </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                               </router-link>&ndash;&gt;-->
<!--&lt;!&ndash;                                           </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                       </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                       <div class="col-md-6">&ndash;&gt;-->
<!--&lt;!&ndash;                                           <div class="feature-box">&ndash;&gt;-->
<!--&lt;!&ndash;                                               <router-link to="/sur">&ndash;&gt;-->
<!--&lt;!&ndash;                                                   <div class="feat-text">&ndash;&gt;-->
<!--&lt;!&ndash;                                                       <img src="../assets/item/business-and-finance2.png">&ndash;&gt;-->
<!--&lt;!&ndash;                                                       <p>Сургалтын байгууллага</p>&ndash;&gt;-->
<!--&lt;!&ndash;                                                       <span>Политехник коллеж, мэргэжил сургалт үйлдвэрлэлийн төв</span>&ndash;&gt;-->
<!--&lt;!&ndash;                                                   </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                               </router-link>&ndash;&gt;-->
<!--&lt;!&ndash;                                           </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                       </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                        <div class="col-md-6">&ndash;&gt;-->
<!--&lt;!&ndash;                                          <div class="feature-box">&ndash;&gt;-->
<!--&lt;!&ndash;                                            <router-link to="/s_tuv">&ndash;&gt;-->
<!--&lt;!&ndash;                                              <div class="feat-text">&ndash;&gt;-->
<!--&lt;!&ndash;                                                <img src="../assets/item/certificate.png">&ndash;&gt;-->
<!--&lt;!&ndash;                                                <p>Сургалтын төв</p>&ndash;&gt;-->
<!--&lt;!&ndash;                                                <span>Сургалтын төв</span>&ndash;&gt;-->
<!--&lt;!&ndash;                                              </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                            </router-link>&ndash;&gt;-->
<!--&lt;!&ndash;                                          </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                        </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                       <div class="col-6 col-md-3">&ndash;&gt;-->
<!--&lt;!&ndash;                                           <div class="feature-box">&ndash;&gt;-->
<!--&lt;!&ndash;                                               <a href="http://chadamj.tvets.edu.mn" target="_blank">&ndash;&gt;-->
<!--&lt;!&ndash;                                                   <div class="feat-text">&ndash;&gt;-->
<!--&lt;!&ndash;                                                       <img src="../assets/item/line.png">&ndash;&gt;-->
<!--&lt;!&ndash;                                                       <p>Чадамжийн сан</p>&ndash;&gt;-->
<!--&lt;!&ndash;                                                       <span>Мэргэжлийн сургалт, мэргэжлийн боловсрол, техникийн боловсрол</span>&ndash;&gt;-->
<!--&lt;!&ndash;                                                   </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                               </a>&ndash;&gt;-->
<!--&lt;!&ndash;                                           </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                       </div>&ndash;&gt;-->
<!--                                   </div>-->
<!--                                      <div class="row">-->
<!--                                        <div class="col-6 col-md-3">-->
<!--                                          <div class="feature-box">-->
<!--                                            <router-link to="/sur">-->
<!--                                              <div class="feat-text">-->
<!--                                                <img src="../assets/item/business-and-finance2.png">-->
<!--                                                <p>Сургалтын байгууллага</p>-->
<!--                                                <span>Политехник коллеж, мэргэжил сургалт үйлдвэрлэлийн төв</span>-->
<!--                                              </div>-->
<!--                                            </router-link>-->
<!--                                          </div>-->
<!--                                        </div>-->
<!--                                       <div class="col-6 col-md-3">-->
<!--                                           <div class="feature-box">-->
<!--                                               <router-link to="/hvnii_nuuts">-->
<!--                                                   <div class="feat-text">-->
<!--                                                       <img src="../assets/item/friends.png">-->
<!--                                                       <p>Багш хүний нөөц</p>-->
<!--                                                       <span>Техникийн боловсрол, мэргэжлийн боловсрол</span>-->
<!--                                                   </div>-->
<!--                                               </router-link>-->
<!--                                           </div>-->
<!--                                       </div>-->
<!--&lt;!&ndash;                                       <div class="col-6 col-md-3">&ndash;&gt;-->
<!--&lt;!&ndash;                                           <div class="feature-box">&ndash;&gt;-->
<!--&lt;!&ndash;                                             <a href="javascript:void(0)">&ndash;&gt;-->
<!--&lt;!&ndash;                                                   <div class="feat-text">&ndash;&gt;-->
<!--&lt;!&ndash;                                                       <img src="../assets/item/computer.png">&ndash;&gt;-->
<!--&lt;!&ndash;                                                       <p>Цахим сургалт</p>&ndash;&gt;-->
<!--&lt;!&ndash;                                                       <span>Цахим сургалт</span>&ndash;&gt;-->
<!--&lt;!&ndash;                                                   </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                             </a>&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;                                             <a href="https://mergejil-elearning.de/Resource%20Pool/content/?fbclid=IwAR0d22lVy0j8XxpmV1LmXoGGkoy__fRHdeEdZXbY50RQ561FBgZiL1hUL8g#/" target="_blank">&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;                                               <div class="feat-text">&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;                                                 <img src="../assets/item/computer.png">&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;                                                 <p>Цахим сургалт</p>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;                                                 <span>Цахим сургалт</span>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;                                               </div>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;                                             </a>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;                                           </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                       </div>&ndash;&gt;-->
<!--                                       <div class="col-6 col-md-3">-->
<!--                                           <div class="feature-box">-->
<!--                                               <router-link to="/orchin">-->
<!--                                                   <div class="feat-text">-->
<!--                                                       <img src="../assets/item/desk.png">-->
<!--                                                       <p>Сургалтын орчин</p>-->
<!--                                                       <span>Сургалтын орчин, хэрэглэгдэхүүн</span>-->
<!--                                                   </div>-->
<!--                                               </router-link>-->
<!--                                           </div>-->
<!--                                       </div>-->
<!--                                        <div class="col-6 col-md-3">-->
<!--                                          <div class="feature-box">-->
<!--                                            <router-link to="/tetgeleg">-->
<!--                                              <div class="feat-text">-->
<!--                                                <img src="../assets/item/business-and-finance5.png">-->
<!--                                                <p>Тэтгэлэг</p>-->
<!--                                                <span>Тэтгэлэг тайлан мэдээ</span>-->
<!--                                              </div>-->
<!--                                            </router-link>-->
<!--                                          </div>-->
<!--                                        </div>-->
<!--&lt;!&ndash;                                       <div class="col-6 col-md-3">&ndash;&gt;-->
<!--&lt;!&ndash;                                           <div class="feature-box">&ndash;&gt;-->
<!--&lt;!&ndash;                                               &lt;!&ndash;                               <a href="">&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;                                               <div class="feat-text" @click="erpUnelgee = true">&ndash;&gt;-->
<!--&lt;!&ndash;                                                   <img src="../assets/item/essay1.png" class="none">&ndash;&gt;-->
<!--&lt;!&ndash;                                                   &lt;!&ndash;                                       <img src="../assets/item/essay1.png" >&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;                                                   <p>RPL үнэлгээ</p>&ndash;&gt;-->
<!--&lt;!&ndash;                                                   <span>Албан ба албан бус сургалт, амьдрах орчны хүрээнд мэдлэг, ур чадввар эзэмшсэн иргэний мэргэшлийг түвшинг үнэлж, үнэлгээг баталгаажуулах, гэрчилгээжүүлэх</span>&ndash;&gt;-->

<!--&lt;!&ndash;                                               </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                               &lt;!&ndash;                               </a>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;                                           </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                       </div>&ndash;&gt;-->
<!--                                   </div>-->
<!--                                      <div class="row">-->
<!--                                       <div class="col-6 col-md-3">-->
<!--                                           <div class="feature-box">-->
<!--                                               <a  @click="modal1 = true">-->
<!--                                                   <div class="feat-text">-->
<!--                                                       <img src="../assets/item/gerchilgee.png" >-->
<!--                                                       <p>Гэрчилгээ, үнэмлэх, диплом шалгах</p>-->
<!--                                                       <span>Мэргэжлийн үнэмлэх, мэргэжлийн боловсролын үнэмлэх, мэргэжлийн диплом, чардамжийн гэрчилгээ</span>-->
<!--                                                   </div>-->
<!--                                               </a>-->
<!--                                           </div>-->
<!--                                       </div>-->
<!--                                       <div class="col-6 col-md-3">-->
<!--                                           <div class="feature-box">-->
<!--                                               &lt;!&ndash;                               <a href="">&ndash;&gt;-->
<!--                                               <div class="feat-text" @click="nuhunOgolt = true">-->
<!--                                                   <img src="../assets/item/expenses1.png" class="none">-->
<!--                                                   &lt;!&ndash;                                       <img src="../assets/item/expenses1.png">&ndash;&gt;-->
<!--                                                   <p>Нөхөн олголт</p>-->
<!--                                                    <span>Төгсөгчийн боловсролын баримт бичгийн нөхөн олголт</span>-->

<!--                                               </div>-->
<!--                                               &lt;!&ndash;                               </a>&ndash;&gt;-->
<!--                                           </div>-->
<!--                                       </div>-->
<!--                                       <div class="col-6 col-md-3">-->
<!--                                           <div class="feature-box">-->
<!--                                               <router-link to="/statistic_cat">-->
<!--                                                   <div class="feat-text">-->
<!--                                                       <img src="../assets/item/business-and-finance6.png">-->
<!--                                                       <p> Статистик</p>-->
<!--                                                       <span>Суралцагч, сургалтын байгууллага, хүний нөөц</span>-->
<!--                                                   </div>-->
<!--                                               </router-link>-->
<!--                                           </div>-->
<!--                                       </div>-->
<!--                                        <div class="col-6 col-md-3">-->
<!--                                          <div class="feature-box">-->
<!--                                            <div class="feat-text">-->
<!--                                              <img src="../assets/item/shilenDanc.png" class="last_row">-->
<!--                                              <p>Шилэн данс</p>-->
<!--                                              <ul>-->
<!--                                                <li class="shilendans" :key="index" v-for="(shilendan, index) in shilendans"><a :href="shilendan.link" target="_blank">{{shilendan.shilendans}}</a></li>-->
<!--                                              </ul>-->
<!--                                              &lt;!&ndash;                                   <ul>&ndash;&gt;-->
<!--                                              &lt;!&ndash;                                       <li class="shilendans"><a href="https://shilendans.gov.mn/orglist/41" target="_blank">Сургалтын байгууллагуудын хувьсах зардал</a></li>&ndash;&gt;-->
<!--                                              &lt;!&ndash;                                       <li class="shilendans"><a href="https://info.shilendans.gov.mn/login" target="_blank">Мэргэжлийн боловсрол, сургалтын үнэлгээ, мэдээлэл арга зүйн төвийн шилэн данс</a></li>&ndash;&gt;-->
<!--                                              &lt;!&ndash;                                   </ul>&ndash;&gt;-->
<!--                                            </div>-->
<!--                                          </div>-->
<!--                                        </div>-->
<!--                                   </div>-->
<!--                                      <div class="row">-->
<!--&lt;!&ndash;                                       <div class="col-6 col-md-3">&ndash;&gt;-->
<!--&lt;!&ndash;                                           <div class="feature-box">&ndash;&gt;-->
<!--&lt;!&ndash;                                               <a href="http://mlsp.gov.mn/nnews/394" target="_blank">&ndash;&gt;-->
<!--&lt;!&ndash;                                                   <div class="feat-text">&ndash;&gt;-->
<!--&lt;!&ndash;                                                       <img src="../assets/item/hnhy_yam.png" class="last_row">&ndash;&gt;-->
<!--&lt;!&ndash;                                                       <p>ХНХЯ, Мэргэжлийн боловсрол, сургалтын...</p>&ndash;&gt;-->
<!--&lt;!&ndash;                                                       <span>ХНХЯ, мэргэжлийн боловсрол, сургалтын бодлогын хэрэгжилтийг зохицуулах газар</span>&ndash;&gt;-->
<!--&lt;!&ndash;                                                   </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                               </a>&ndash;&gt;-->
<!--&lt;!&ndash;                                           </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                       </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                       <div class="col-6 col-md-3">&ndash;&gt;-->
<!--&lt;!&ndash;                                           <div class="feature-box">&ndash;&gt;-->
<!--&lt;!&ndash;                                               <router-link to="/mbsut">&ndash;&gt;-->
<!--&lt;!&ndash;                                                   <div class="feat-text">&ndash;&gt;-->
<!--&lt;!&ndash;                                                       <img src="../assets/item/small_logo.png" class="last_row">&ndash;&gt;-->
<!--&lt;!&ndash;                                                       <p>Мэргэжлийн боловсрол, сургалтын үнэлгээ мэдээлэл, аргазүйн төв</p>&ndash;&gt;-->
<!--&lt;!&ndash;                                                       <span>Мэргэжлийн боловсрол, сургалтын үнэлгээ мэдээлэл, аргазүйн төв</span>&ndash;&gt;-->
<!--&lt;!&ndash;                                                   </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                               </router-link>&ndash;&gt;-->
<!--&lt;!&ndash;                                           </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                       </div>&ndash;&gt;-->
<!--                                       <div class="col-6 col-md-3">-->
<!--                                           <div class="feature-box">-->
<!--                                               <router-link to="/tvnshlel">-->
<!--                                                   <div class="feat-text">-->
<!--                                                       <img src="../assets/item/bank-check.png" class="last_row">-->
<!--                                                       <p> Нийгмийн түншлэл</p>-->
<!--                                                       <span>Төсөл хөтөлбөрүүд, төрийн бус байгууллагууд, аж ахуй нэгжүүд</span>-->
<!--                                                   </div>-->
<!--                                               </router-link>-->
<!--                                           </div>-->
<!--                                       </div>-->
<!--                                   </div>-->
<!--                                   </div>-->
<!--                               </TabPane>-->
<!--                               <TabPane label="СУРАЛЦАГЧ" name="name2">-->
<!--                                   <div class="main_tab">-->
<!--                                       <div class="row">-->
<!--                                           <div class="col-6 col-md-3">-->
<!--                                               <div class="feature-box">-->
<!--                                                   <router-link to="/sur">-->
<!--                                                       <div class="feat-text">-->
<!--                                                           <img src="../assets/item/business-and-finance2.png">-->
<!--                                                           <p>Сургалтын байгууллага</p>-->
<!--                                                           <span>Политехник коллеж, мэргэжил сургалт үйлдвэрлэлийн төв</span>-->
<!--                                                       </div>-->
<!--                                                   </router-link>-->
<!--                                               </div>-->
<!--                                           </div>-->
<!--                                         <div class="col-6 col-md-3">-->
<!--                                           <div class="feature-box">-->
<!--                                             <router-link to="/s_tuv">-->
<!--                                               <div class="feat-text">-->
<!--                                                 <img src="../assets/item/certificate.png">-->
<!--                                                 <p>Сургалтын төв</p>-->
<!--                                                 <span>Сургалтын төв</span>-->
<!--                                               </div>-->
<!--                                             </router-link>-->
<!--                                           </div>-->
<!--                                         </div>-->
<!--                                           <div class="col-6 col-md-3">-->
<!--                                               <div class="feature-box">-->
<!--                                                   <a href="https://mergejil-elearning.de/Resource%20Pool/content/?fbclid=IwAR0d22lVy0j8XxpmV1LmXoGGkoy__fRHdeEdZXbY50RQ561FBgZiL1hUL8g#/" target="_blank">-->
<!--                                                       <div class="feat-text">-->
<!--                                                           <img src="../assets/item/computer.png">-->
<!--                                                           <p>Цахим сургалт</p>-->
<!--                                                           <span>Цахим сургалт</span>-->
<!--                                                       </div>-->
<!--                                                   </a>-->
<!--                                               </div>-->
<!--                                           </div>-->
<!--                                           <div class="col-6 col-md-3">-->
<!--                                               <div class="feature-box">-->
<!--                                                   &lt;!&ndash;                               <a href="">&ndash;&gt;-->
<!--                                                   <div class="feat-text" @click="erpUnelgee = true">-->
<!--                                                   <img src="../assets/item/essay1.png" class="none">-->
<!--                                                   &lt;!&ndash;                                       <img src="../assets/item/essay1.png" >&ndash;&gt;-->
<!--                                                   <p>RPL үнэлгээ</p>-->
<!--                                                   <span>Албан ба албан бус сургалт, амьдрах орчны хүрээнд мэдлэг, ур чадввар эзэмшсэн иргэний мэргэшлийг түвшинг үнэлж, үнэлгээг баталгаажуулах, гэрчилгээжүүлэх</span>-->

<!--                                               </div>-->
<!--                                                   &lt;!&ndash;                               </a>&ndash;&gt;-->
<!--                                               </div>-->
<!--                                           </div>-->
<!--                                           <div class="col-6 col-md-3">-->
<!--                                               <div class="feature-box">-->
<!--                                                   <a href="http://chadamj.tvets.edu.mn" target="_blank">-->
<!--                                                       <div class="feat-text">-->
<!--                                                           <img src="../assets/item/line.png">-->
<!--                                                           <p>Чадамжийн сан</p>-->
<!--                                                           <span>Мэргэжлийн сургалт, мэргэжлийн боловсрол, техникийн боловсрол</span>-->
<!--                                                       </div>-->
<!--                                                   </a>-->
<!--                                               </div>-->
<!--                                           </div>-->
<!--                                           <div class="col-6 col-md-3">-->
<!--                                               <div class="feature-box">-->
<!--                                                   <router-link to="/tetgeleg">-->
<!--                                                       <div class="feat-text">-->
<!--                                                           <img src="../assets/item/business-and-finance5.png">-->
<!--                                                           <p>Тэтгэлэг</p>-->
<!--                                                           <span>Тэтгэлэг тайлан мэдээ</span>-->
<!--                                                       </div>-->
<!--                                                   </router-link>-->
<!--                                               </div>-->
<!--                                           </div>-->
<!--                                           <div class="col-6 col-md-3">-->
<!--                                               <div class="feature-box">-->
<!--                                                   <a  @click="modal1 = true">-->
<!--                                                       <div class="feat-text">-->

<!--                                                           <img src="../assets/item/gerchilgee.png" >-->
<!--                                                           <p>Гэрчилгээ, үнэмлэх, диплом шалгах</p>-->
<!--                                                           <span>Мэргэжлийн үнэмлэх, мэргэжлийн боловсролын үнэмлэх, мэргэжлийн диплом, чардамжийн гэрчилгээ</span>-->
<!--                                                       </div>-->
<!--                                                   </a>-->
<!--                                               </div>-->
<!--                                           </div>-->
<!--                                           <div class="col-6 col-md-3">-->
<!--                                               <div class="feature-box">-->
<!--                                                   &lt;!&ndash;                               <a href="">&ndash;&gt;-->
<!--                                                   <div class="feat-text" @click="nuhunOgolt = true">-->
<!--                                                       <img src="../assets/item/expenses1.png" class="none">-->
<!--                                                       &lt;!&ndash;                                       <img src="../assets/item/expenses1.png">&ndash;&gt;-->
<!--                                                       <p>Нөхөн олголт</p>-->
<!--                                                       <span>Төгсөгчийн боловсролын баримт бичгийн нөхөн олголт</span>-->
<!--                                                   </div>-->
<!--                                                   &lt;!&ndash;                               </a>&ndash;&gt;-->
<!--                                               </div>-->
<!--                                           </div>-->
<!--                                           <div class="col-6 col-md-3">-->
<!--                                               <div class="feature-box">-->
<!--                                                   <router-link to="/mbsut">-->
<!--                                                       <div class="feat-text">-->
<!--                                                           <img src="../assets/item/small_logo.png" class="last_row">-->
<!--                                                           <p>Мэргэжлийн боловсрол, сургалтын үнэлгээ мэдээлэл, аргазүйн төв</p>-->
<!--                                                           <span>Мэргэжлийн боловсрол, сургалтын үнэлгээ мэдээлэл, аргазүйн төв</span>-->
<!--                                                       </div>-->
<!--                                                   </router-link>-->
<!--                                               </div>-->
<!--                                           </div>-->
<!--                                       </div>-->
<!--                                   </div>-->
<!--                               </TabPane>-->
<!--                               <TabPane label="СУРГАЛТЫН БАЙГУУЛЛАГА" name="name3">-->
<!--                                   <div class="main_tab">-->
<!--                                       <div class="row">-->
<!--&lt;!&ndash;                                           <div class="col-6 col-md-3">&ndash;&gt;-->
<!--&lt;!&ndash;                                               <div class="feature-box">&ndash;&gt;-->
<!--&lt;!&ndash;                                                   <router-link to="/tusgai">&ndash;&gt;-->
<!--&lt;!&ndash;                                                       <div class="feat-text">&ndash;&gt;-->
<!--&lt;!&ndash;                                                           <img src="../assets/item/certificate2.png">&ndash;&gt;-->
<!--&lt;!&ndash;                                                           <p>Тусгай зөвшөөрөл</p>&ndash;&gt;-->
<!--&lt;!&ndash;                                                           <span>Мэргэжил сургалт, үйлдвэрлэлийн төв, Политехник коллеж</span>&ndash;&gt;-->
<!--&lt;!&ndash;                                                       </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                                   </router-link>&ndash;&gt;-->
<!--&lt;!&ndash;                                               </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                           </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                           <div class="col-6 col-md-3">&ndash;&gt;-->
<!--&lt;!&ndash;                                               <div class="feature-box">&ndash;&gt;-->
<!--&lt;!&ndash;                                                   <router-link to="/SBG">&ndash;&gt;-->
<!--&lt;!&ndash;                                                       <div class="feat-text">&ndash;&gt;-->
<!--&lt;!&ndash;                                                           <img src="../assets/item/certificate.png">&ndash;&gt;-->
<!--&lt;!&ndash;                                                           <p>Мэргэжлийн сургалтын бүртгэлийн гэрчилгээ</p>&ndash;&gt;-->
<!--&lt;!&ndash;                                                           <span>Сургалтын төв</span>&ndash;&gt;-->
<!--&lt;!&ndash;                                                       </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                                   </router-link>&ndash;&gt;-->
<!--&lt;!&ndash;                                               </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                           </div>&ndash;&gt;-->
<!--                                           <div class="col-6 col-md-3">-->
<!--                                               <div class="feature-box">-->
<!--                                                   <router-link to="/sur">-->
<!--                                                       <div class="feat-text">-->
<!--                                                           <img src="../assets/item/business-and-finance2.png">-->
<!--                                                           <p>Сургалтын байгууллага</p>-->
<!--                                                           <span>Политехник коллеж, мэргэжил сургалт үйлдвэрлэлийн төв</span>-->
<!--                                                       </div>-->
<!--                                                   </router-link>-->
<!--                                               </div>-->
<!--                                           </div>-->
<!--                                         <div class="col-6 col-md-3">-->
<!--                                           <div class="feature-box">-->
<!--                                             <router-link to="/s_tuv">-->
<!--                                               <div class="feat-text">-->
<!--                                                 <img src="../assets/item/certificate.png">-->
<!--                                                 <p>Сургалтын төв</p>-->
<!--                                                 <span>Сургалтын төв</span>-->
<!--                                               </div>-->
<!--                                             </router-link>-->
<!--                                           </div>-->
<!--                                         </div>-->
<!--                                           <div class="col-6 col-md-3">-->
<!--                                               <div class="feature-box">-->
<!--                                                   <a href="http://chadamj.tvets.edu.mn" target="_blank">-->
<!--                                                       <div class="feat-text">-->
<!--                                                           <img src="../assets/item/line.png">-->
<!--                                                           <p>Чадамжийн сан</p>-->
<!--                                                           <span>Мэргэжлийн сургалт, мэргэжлийн боловсрол, техникийн боловсрол</span>-->
<!--                                                       </div>-->
<!--                                                   </a>-->
<!--                                               </div>-->
<!--                                           </div>-->
<!--                                           <div class="col-6 col-md-3">-->
<!--                                               <div class="feature-box">-->
<!--                                                   <router-link to="/hvnii_nuuts">-->
<!--                                                       <div class="feat-text">-->
<!--                                                           <img src="../assets/item/friends.png">-->
<!--                                                           <p>Багш хүний нөөц</p>-->
<!--                                                           <span>Техникийн боловсрол, мэргэжлийн боловсрол</span>-->
<!--                                                       </div>-->
<!--                                                   </router-link>-->
<!--                                               </div>-->
<!--                                           </div>-->
<!--                                           <div class="col-6 col-md-3">-->
<!--                                               <div class="feature-box">-->
<!--                                                   <a href="https://mergejil-elearning.de/Resource%20Pool/content/?fbclid=IwAR0d22lVy0j8XxpmV1LmXoGGkoy__fRHdeEdZXbY50RQ561FBgZiL1hUL8g#/" target="_blank">-->
<!--                                                       <div class="feat-text">-->
<!--                                                           <img src="../assets/item/computer.png">-->
<!--                                                           <p>Цахим сургалт</p>-->
<!--                                                           <span>Цахим сургалт</span>-->
<!--                                                       </div>-->
<!--                                                   </a>-->
<!--                                               </div>-->
<!--                                           </div>-->
<!--                                           <div class="col-6 col-md-3">-->
<!--                                               <div class="feature-box">-->
<!--                                                   <router-link to="/orchin">-->
<!--                                                       <div class="feat-text">-->
<!--                                                           <img src="../assets/item/desk.png">-->
<!--                                                           <p>Сургалтын орчин</p>-->
<!--                                                           <span>Сургалтын орчин, хэрэглэгдэхүүн</span>-->
<!--                                                       </div>-->
<!--                                                   </router-link>-->
<!--                                               </div>-->
<!--                                           </div>-->
<!--                                           <div class="col-6 col-md-3">-->
<!--                                               <div class="feature-box">-->
<!--                                                   <router-link to="/tetgeleg">-->
<!--                                                       <div class="feat-text">-->
<!--                                                           <img src="../assets/item/business-and-finance5.png">-->
<!--                                                           <p>Тэтгэлэг</p>-->
<!--                                                           <span>Тэтгэлэг тайлан мэдээ</span>-->
<!--                                                       </div>-->
<!--                                                   </router-link>-->
<!--                                               </div>-->
<!--                                           </div>-->
<!--                                       </div>-->
<!--                                   </div>-->
<!--                               </TabPane>-->
<!--                               <TabPane label="СУДЛААЧ" name="name4">-->
<!--                                   <div class="main_tab">-->
<!--                                       <div class="row">-->
<!--&lt;!&ndash;                                           <div class="col-6 col-md-3">&ndash;&gt;-->
<!--&lt;!&ndash;                                               <div class="feature-box">&ndash;&gt;-->
<!--&lt;!&ndash;                                                   <router-link to="/tusgai">&ndash;&gt;-->
<!--&lt;!&ndash;                                                       <div class="feat-text">&ndash;&gt;-->
<!--&lt;!&ndash;                                                           <img src="../assets/item/certificate2.png">&ndash;&gt;-->
<!--&lt;!&ndash;                                                           <p>Тусгай зөвшөөрөл</p>&ndash;&gt;-->
<!--&lt;!&ndash;                                                           <span>Мэргэжил сургалт, үйлдвэрлэлийн төв, Политехник коллеж</span>&ndash;&gt;-->
<!--&lt;!&ndash;                                                       </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                                   </router-link>&ndash;&gt;-->
<!--&lt;!&ndash;                                               </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                           </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                           <div class="col-6 col-md-3">&ndash;&gt;-->
<!--&lt;!&ndash;                                               <div class="feature-box">&ndash;&gt;-->
<!--&lt;!&ndash;                                                   <router-link to="/SBG">&ndash;&gt;-->
<!--&lt;!&ndash;                                                       <div class="feat-text">&ndash;&gt;-->
<!--&lt;!&ndash;                                                           <img src="../assets/item/certificate.png">&ndash;&gt;-->
<!--&lt;!&ndash;                                                           <p>Мэргэжлийн сургалтын бүртгэлийн гэрчилгээ</p>&ndash;&gt;-->
<!--&lt;!&ndash;                                                           <span>Сургалтын төв</span>&ndash;&gt;-->
<!--&lt;!&ndash;                                                       </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                                   </router-link>&ndash;&gt;-->
<!--&lt;!&ndash;                                               </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                           </div>&ndash;&gt;-->
<!--                                           <div class="col-6 col-md-3">-->
<!--                                               <div class="feature-box">-->
<!--                                                   <router-link to="/sur">-->
<!--                                                       <div class="feat-text">-->
<!--                                                           <img src="../assets/item/business-and-finance2.png">-->
<!--                                                           <p>Сургалтын байгууллага</p>-->
<!--                                                           <span>Политехник коллеж, мэргэжил сургалт үйлдвэрлэлийн төв</span>-->
<!--                                                       </div>-->
<!--                                                   </router-link>-->
<!--                                               </div>-->
<!--                                           </div>-->
<!--                                         <div class="col-6 col-md-3">-->
<!--                                           <div class="feature-box">-->
<!--                                             <router-link to="/s_tuv">-->
<!--                                               <div class="feat-text">-->
<!--                                                 <img src="../assets/item/certificate.png">-->
<!--                                                 <p>Сургалтын төв</p>-->
<!--                                                 <span>Сургалтын төв</span>-->
<!--                                               </div>-->
<!--                                             </router-link>-->
<!--                                           </div>-->
<!--                                         </div>-->
<!--                                           <div class="col-6 col-md-3">-->
<!--                                               <div class="feature-box">-->
<!--                                                   <a href="http://chadamj.tvets.edu.mn" target="_blank">-->
<!--                                                       <div class="feat-text">-->
<!--                                                           <img src="../assets/item/line.png">-->
<!--                                                           <p>Чадамжийн сан</p>-->
<!--                                                           <span>Мэргэжлийн сургалт, мэргэжлийн боловсрол, техникийн боловсрол</span>-->
<!--                                                       </div>-->
<!--                                                   </a>-->
<!--                                               </div>-->
<!--                                           </div>-->
<!--                                           <div class="col-6 col-md-3">-->
<!--                                               <div class="feature-box">-->
<!--                                                   <router-link to="/hvnii_nuuts">-->
<!--                                                       <div class="feat-text">-->
<!--                                                           <img src="../assets/item/friends.png">-->
<!--                                                           <p>Багш хүний нөөц</p>-->
<!--                                                           <span>Техникийн боловсрол, мэргэжлийн боловсрол</span>-->
<!--                                                       </div>-->
<!--                                                   </router-link>-->
<!--                                               </div>-->
<!--                                           </div>-->
<!--                                           <div class="col-6 col-md-3">-->
<!--                                               <div class="feature-box">-->
<!--                                                   <router-link to="/orchin">-->
<!--                                                       <div class="feat-text">-->
<!--                                                           <img src="../assets/item/desk.png">-->
<!--                                                           <p>Сургалтын орчин</p>-->
<!--                                                           <span>Сургалтын орчин, хэрэглэгдэхүүн</span>-->
<!--                                                       </div>-->
<!--                                                   </router-link>-->
<!--                                               </div>-->
<!--                                           </div>-->
<!--                                           <div class="col-6 col-md-3">-->
<!--                                               <div class="feature-box">-->
<!--                                                   <router-link to="/tetgeleg">-->
<!--                                                       <div class="feat-text">-->
<!--                                                           <img src="../assets/item/business-and-finance5.png">-->
<!--                                                           <p>Тэтгэлэг</p>-->
<!--                                                           <span>Тэтгэлэг тайлан мэдээ</span>-->
<!--                                                       </div>-->
<!--                                                   </router-link>-->
<!--                                               </div>-->
<!--                                           </div>-->
<!--                                           <div class="col-6 col-md-3">-->
<!--                                               <div class="feature-box">-->
<!--                                                   <router-link to="/statistic_cat">-->
<!--                                                       <div class="feat-text">-->
<!--                                                           <img src="../assets/item/business-and-finance6.png">-->
<!--                                                           <p> Статистик</p>-->
<!--                                                           <span>Суралцагч, сургалтын байгууллага, хүний нөөц</span>-->
<!--                                                       </div>-->
<!--                                                   </router-link>-->
<!--                                               </div>-->
<!--                                           </div>-->
<!--                                           <div class="col-6 col-md-3">-->
<!--                                               <div class="feature-box">-->
<!--                                                   <div class="feat-text">-->
<!--                                                       <img src="../assets/item/shilenDanc.png" class="last_row">-->
<!--                                                       <p>Шилэн данс</p>-->
<!--                                                       <ul>-->
<!--                                                           <li class="shilendans" :key="index" v-for="(shilendan, index) in shilendans"><a :href="shilendan.link" target="_blank">{{shilendan.shilendans}}</a></li>-->
<!--                                                       </ul>-->
<!--                                                       &lt;!&ndash;                                   <ul>&ndash;&gt;-->
<!--                                                       &lt;!&ndash;                                       <li class="shilendans"><a href="https://shilendans.gov.mn/orglist/41" target="_blank">Сургалтын байгууллагуудын хувьсах зардал</a></li>&ndash;&gt;-->
<!--                                                       &lt;!&ndash;                                       <li class="shilendans"><a href="https://info.shilendans.gov.mn/login" target="_blank">Мэргэжлийн боловсрол, сургалтын үнэлгээ, мэдээлэл арга зүйн төвийн шилэн данс</a></li>&ndash;&gt;-->
<!--                                                       &lt;!&ndash;                                   </ul>&ndash;&gt;-->
<!--                                                   </div>-->
<!--                                               </div>-->
<!--                                           </div>-->
<!--                                           <div class="col-6 col-md-3">-->
<!--                                               <div class="feature-box">-->
<!--                                                   <a href="http://mlsp.gov.mn/nnews/394" target="_blank">-->
<!--                                                       <div class="feat-text">-->
<!--                                                           <img src="../assets/item/hnhy_yam.png" class="last_row">-->
<!--                                                           <p>ХНХЯ, Мэргэжлийн боловсрол, сургалтын...</p>-->
<!--                                                           <span>ХНХЯ, мэргэжлийн боловсрол, сургалтын бодлогын хэрэгжилтийг зохицуулах газар</span>-->
<!--                                                       </div>-->
<!--                                                   </a>-->
<!--                                               </div>-->
<!--                                           </div>-->
<!--                                           <div class="col-6 col-md-3">-->
<!--                                               <div class="feature-box">-->
<!--                                                   <router-link to="/mbsut">-->
<!--                                                       <div class="feat-text">-->
<!--                                                           <img src="../assets/item/small_logo.png" class="last_row">-->
<!--                                                           <p>Мэргэжлийн боловсрол, сургалтын үнэлгээ мэдээлэл, аргазүйн төв</p>-->
<!--                                                           <span>Мэргэжлийн боловсрол, сургалтын үнэлгээ мэдээлэл, аргазүйн төв</span>-->
<!--                                                       </div>-->
<!--                                                   </router-link>-->
<!--                                               </div>-->
<!--                                           </div>-->
<!--                                           <div class="col-6 col-md-3">-->
<!--                                               <div class="feature-box">-->
<!--                                                   <router-link to="/tvnshlel">-->
<!--                                                       <div class="feat-text">-->
<!--                                                           <img src="../assets/item/bank-check.png" class="last_row">-->
<!--                                                           <p> Нийгмийн түншлэл</p>-->
<!--                                                           <span>Төсөл хөтөлбөрүүд, төрийн бус байгууллагууд, аж ахуй нэгжүүд</span>-->
<!--                                                       </div>-->
<!--                                                   </router-link>-->
<!--                                               </div>-->
<!--                                           </div>-->
<!--                                       </div>-->
<!--                                   </div>-->
<!--                               </TabPane>-->
<!--                           </Tabs>-->

           </div>
           <Mergejil></Mergejil>
           <div class="home_news">
               <div class="row">
                   <div class="col-md-12">
                       <h3 class="title">МЭДЭЭ, МЭДЭЭЛЭЛ <div class="view_button"><router-link to="/news" class="home_btn"><i class="fa fa-arrow-circle-o-right" aria-hidden="true"></i>Бүгдийг харах</router-link></div></h3>
                   </div>
               </div>
<!--               <div class="row">-->
<!--                   <div class="col-md-4"  :key="index" v-for="(last, index) in lastbefore">-->
<!--                          <div class="item">-->
<!--                              <router-link :to="`/newsDetails/${last.id}`">-->
<!--                                  <div class="view view-first">-->
<!--                                      <a href="">-->
<!--                                          <img :src="last.thumb" alt="">-->
<!--&lt;!&ndash;                                          <div class="mask">&ndash;&gt;-->
<!--&lt;!&ndash;                                              <div class="i-icons">&ndash;&gt;-->
<!--&lt;!&ndash;                                                  <router-link to="" class="re-details"><i class="fa fa-arrow-circle-o-right"></i></router-link>&ndash;&gt;-->
<!--&lt;!&ndash;                                              </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                          </div>&ndash;&gt;-->
<!--                                      </a>-->
<!--                                  </div>-->
<!--                                  <div class="repost-text">-->
<!--                                      <router-link  to="/newsDetails" class="title">Цаг үеийн мэдээ</router-link>-->
<!--                                      <p>{{last.title_mn}}</p>-->
<!--                                  </div>-->
<!--                                  <ul class="post-tags clearfix">-->
<!--                                      <li>{{last.created_at | date}}</li>-->
<!--                                      <li class="right">Цааш унших <i class="fa fa-chevron-right"></i></li>-->
<!--                                  </ul>-->
<!--                              </router-link>-->
<!--                          </div>-->
<!--                      </div>-->
<!--               </div>-->

           </div>
           <div class="home-top">
               <div class="row">
                   <div class="col-md-6">
                     <swiper class="swiper" ref="swiper" :options="swiperOption1">
                       <swiper-slide :key="index" v-for="(vedio, index) in vedios">
                         <div class="slide">
                           <div>
                             <div class="home-top-left" >
                               <youtube  :video-id="getVideo(vedio.video_link)" player-width="100%"  player-height="295"></youtube>
                             </div>
                             <div class="home-top-left-text" >
                               <h1 > <router-link :to="`/newsDetails/${vedio.id}`">{{vedio.title_mn}}</router-link></h1>
                               <span >{{vedio.updated_at | date}}</span>
                               <div  v-html="vedio.des_mn" class="desc"></div>
                             </div>
                           </div>
                         </div>
                       </swiper-slide>
                     </swiper>
                     <div class="swiper-button-prev-1" slot="button-prev" @click="prev()"><i class="fa fa-chevron-left"></i></div>
                     <div class="swiper-button-next-1" slot="button-next" @click="next()"><i class="fa fa-chevron-right"></i></div>
                   </div>
                   <div class="col-md-6">
                       <div class="home-top-right">
                           <ul class="list-post">
                               <li class="item"  :key="index" v-for="(lastnew, index) in lastnews">
                                   <div class="item_text">
                                       <router-link :to="`/newsDetails/${lastnew.id}`">
                                           <h1 class="news-title">{{lastnew.title_mn}}</h1>
                                       </router-link>
                                       <span>{{lastnew.created_at | date}}</span>
                                       <div v-html="lastnew.des_mn" class="list_desc"></div>
                                   </div>
                                   <div class="item_img">
                                       <div class="image">
                                           <router-link :to="`/newsDetails/${lastnew.id}`">
                                               <img :src="lastnew.thumb" alt="">
                                           </router-link>
                                       </div>
                                   </div>
                               </li>
                           </ul>
                       </div>
                   </div>
               </div>
           </div>
           <AsuultHariult></AsuultHariult>
       </div>
       <Company></Company>

       <Modal
               v-model="modal1"
               :styles="{top: '200px'}">
           <div id="home_modal">
                <div class="m_title">Гэрчилгээ, үнэмлэх, диплом шалгах</div>
                <Button class="button" @click="mergejil_vnemleh = true">Мэргэжлийн үнэмлэх  <i class="fa fa-chevron-right"></i></Button>
                <Button class="button" @click="MBU = true">Мэргэжлийн боловсролын үнэмлэх <i class="fa fa-chevron-right"></i></Button>
                <Button class="button" @click="mergejil_diplom = true">Мэргэжлийн диплом <i class="fa fa-chevron-right"></i></Button>
<!--                <Button class="button" @click="search = true">Чадамжийн гэрчилгээ <i class="fa fa-chevron-right"></i></Button>-->
<!--                <ul>-->
<!--                    <li><a href=""><img src="../assets/android.png" alt=""></a></li>-->
<!--                    <li><a href=""><img src="../assets/apple.png" alt=""></a></li>-->
<!--                </ul>-->
           </div>
           <div slot="footer"></div>
       </Modal>

       <Modal
               v-model="search"
               :styles="{top: '200px'}">
           <div id="gerchilgee">
               <div class="gerchilgee_title">Чадамжийн гэрчилгээ</div>
<!--               <Input v-model="search_value" search enter-button="Шалгах" placeholder="Гэрчилгээний дугаар" @click="dataSearch()" />-->
               <Input v-model="search_value" placeholder="Гэрчилгээний дугаар" style="width: 80%" />
               <button @click="dataSearch()" class="search">Шалгах</button>
             <br>
             <p style="margin-top: 20px; color: #9E1A3C">Чадамжийн гэрчилгээг шалгахдаа дараах мэдээллүүдийг тулгана уу.</p>
             <p>1. Суралцагчийн эцэг/эх -ийн нэр</p>
             <p>2. Суралцагчийн нэр</p>
             <p>3. Суралцагчийн регистрийн дугаар</p>
             <p>4. Чадамжийн гэрчилгээний дугаар</p>
           </div>
           <div slot="footer"></div>
       </Modal>
       <Modal
               v-model="mergejil_diplom"
               :styles="{top: '200px'}">
           <div id="mergejil_diplom">
               <div class="mergejil_diplom_title">Мэргэжлийн диплом</div>
               <!--               <Input v-model="search_value" search enter-button="Шалгах" placeholder="Гэрчилгээний дугаар" @click="dataSearch()" />-->
               <Input v-model="mergejil_diplom_value" placeholder="Мэргэжлийн диплом" style="width: 80%" />
               <button @click="dataMD()" class="search">Шалгах</button>
             <br>
             <p style="margin-top: 20px; color: #9E1A3C">Мэргэжлийн дипломыг шалгахдаа дараах мэдээллүүдийг тулгана уу.</p>
             <p>1. Суралцагчийн эцэг/эх -ийн нэр</p>
             <p>2. Суралцагчийн нэр</p>
             <p>3. Суралцагчийн регистрийн дугаар</p>
             <p>4. Мэргэжлийн дипломны дугаар</p>
           </div>
           <div slot="footer"></div>
       </Modal>
       <Modal
               v-model="MBU"
               :styles="{top: '200px'}">
           <div id="MBU">
               <div class="MBU_title">Мэргэжлийн боловсролын үнэмлэх</div>
               <!--               <Input v-model="search_value" search enter-button="Шалгах" placeholder="Гэрчилгээний дугаар" @click="dataSearch()" />-->
               <Input v-model="MBU_value" placeholder="Мэргэжлийн боловсролын үнэмлэх" style="width: 80%" />
               <button @click="dataMBU()" class="search">Шалгах</button>
             <br>
             <p style="margin-top: 20px; color: #9E1A3C">Мэргэжлийн боловсролын үнэмлэхийг шалгахдаа дараах мэдээллүүдийг тулгана уу.</p>
             <p>1. Суралцагчийн эцэг/эх -ийн нэр</p>
             <p>2. Суралцагчийн нэр</p>
             <p>3. Суралцагчийн регистрийн дугаар</p>
             <p>4. Мэргэжлийн боловсролын үнэмлэхний дугаар</p>
           </div>
           <div slot="footer"></div>
       </Modal>
       <Modal
               v-model="mergejil_vnemleh"
               :styles="{top: '200px'}">
           <div id="mergejil_vnemleh">
               <div class="mergejil_vnemleh_title">Мэргэжлийн үнэмлэх</div>
               <!--               <Input v-model="search_value" search enter-button="Шалгах" placeholder="Гэрчилгээний дугаар" @click="dataSearch()" />-->
               <Input v-model="MU_value" placeholder="Мэргэжлийн үнэмлэх" style="width: 80%" />
               <button @click="dataMU()" class="search">Шалгах</button>
               <br>
               <p style="margin-top: 20px; color: #9E1A3C">Мэргэжлийн үнэмлэхийг шалгахдаа дараах мэдээллүүдийг тулгана уу!</p>
               <p>1. Суралцагчийн эцэг/эх -ийн нэр</p>
               <p>2. Суралцагчийн нэр</p>
               <p>3. Суралцагчийн регистрийн дугаар</p>
               <p>4. Мэргэжлийн үнэмлэхний дугаар</p>
           </div>
           <div slot="footer"></div>
       </Modal>
       <Modal
          width="960px"
               v-model="nuhunOgolt"
               >
           <div id="nuhunOgolt">
             <iframe src="/nuhun-olgolt" frameborder="0"></iframe>
           </div>
           <div slot="footer"></div>
       </Modal>
       <Modal
          width="960px"
               v-model="erpUnelgee"
               >
           <div id="erpUnelgee">
             <iframe src="/rpl-huselt" frameborder="0"></iframe>
             <Alert>Бүртгэл үүссэний дараа нэвтрэх товч дээр дарж нэвтэрнэ үү</Alert>
           </div>
           <div slot="footer"></div>
       </Modal>
   </div>
</template>
<script>
    import {getIdFromURL} from 'vue-youtube-embed';
    import Company from './section/company';
    import Mergejil from './section/home_mergejil';
    import AsuultHariult from './section/asuultHariult';
    import Bairshlaar from './section/bairshlaar';
    export default {
        name: 'Home',
        components: {
            Company: Company,
            Mergejil: Mergejil,
            AsuultHariult: AsuultHariult,
            Bairshlaar: Bairshlaar,
        },
        data () {
            return {
                //videoId: 'ePN0jzFsEb0',
                getVideo: getIdFromURL,
                nuhunOgolt: false,
                erpUnelgee: false,
                modal1: false,
                search: false,
                mergejil_diplom: false,
                MBU: false,
                mergejil_vnemleh: false,
                search_value: '',
                mergejil_diplom_value: '',
                MBU_value: '',
                MU_value: '',
                shilendans: [],
                lastnews: [],
                lastbefore: [],
                vedios: [],

              swiperOption1: {
                slidesPerView: 1,
                spaceBetween: 15,
                navigation: {
                  nextEl: '.swiper-button-next-1',
                  prevEl: '.swiper-button-prev-1'
                },
              },
            }
        },
        mounted () {
            this.home = window.init;
            this.shilendans = window.init.shilendans;
            this.lastnews = window.init.lastnews;
            this.vedios = window.init.news;
             // console.log("this.vedios");
             // console.log(this.vedios);
            this.lastbefore = window.init.lastbefore;
        },
        methods:{
          prev() {
            this.$refs.swiper.$swiper.slidePrev();
          },
          next() {
            this.$refs.swiper.$swiper.slideNext();
          },
            dataSearch(){
                window.open('/check-ch/'+this.search_value, "_blank");
                this.search_value = null;
            },
            dataMD(){
                window.open('/check-md/'+this.mergejil_diplom_value, "_blank");
                this.mergejil_diplom_value = null;
            },
            dataMBU(){
                window.open('/check-mbu/'+this.MBU_value, "_blank");
                this.MBU_value = null;
            },
            dataMU(){
                window.open('/check-mu/'+this.MU_value, "_blank");
                this.MU_value = null;
            }
        }
    }
</script>
